import { isValidElement, type ReactElement } from 'react';
import ErrorImg from '../../assets/error-banner.svg?react';
import InfoImg from '../../assets/info-banner.svg?react';
import WarningImg from '../../assets/warning-banner.svg?react';
import './banner.less';

export type NOTIF_BANNER_TYPE = 'error' | 'warning' | 'info' | 'success';

export interface BannerProps {
  status: NOTIF_BANNER_TYPE;
  message?: string;
  subMessage?: string;
  customIcon?: string | ReactElement | (() => JSX.Element);
  className?: string;
}

const bannerImages: Record<NOTIF_BANNER_TYPE, ReactElement> = {
  error: <ErrorImg />,
  warning: <WarningImg />,
  info: <InfoImg />,
  success: <InfoImg />,
};

export const Banner = ({
  status,
  message,
  subMessage,
  customIcon,
  className = '',
}: BannerProps) => {
  const renderIcon = () => {
    if (typeof customIcon === 'string') {
      return <img src={customIcon} alt={status} />;
    }
    if (isValidElement(customIcon)) {
      return customIcon;
    }
    if (typeof customIcon === 'function') {
      const CustomIconComponent = customIcon;
      return <CustomIconComponent />;
    }
    return bannerImages[status];
  };

  return (
    <div className={`banner-root ${status} ${className}`}>
      {renderIcon()}
      <div className="banner-content">
        <div className="banner-title">{message}</div>
        {!!subMessage && <div className="banner-submessage">{subMessage}</div>}
      </div>
    </div>
  );
};
